export default function formatNumber(number: number | string) {
  if (typeof number === "string") {
    number = parseInt(number)
  }
  return new Intl.NumberFormat().format(number)
}

export const localizeNumber = (
  number: string | number,
  otherProperties?: Record<string, string>,
) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    ...{ otherProperties },
  }).format(Number(number))
}

export const getNumericValue = (input?: string) => {
  if (!input) return
  return Number(input)
}

export const getNumericValueFromDistance = (input?: string) => {
  if (!input) return
  const number = parseFloat(input)
  return Math.round(number)
}

export const getPriceValue = (input?: string) => {
  if (!input) return
  return Number(input.replace(/[^\d.-]/g, ""))
}

export const getValueFromDistance = (input?: string) => {
  if (!input) return
  return parseInt(input?.replace(/[^0-9]/g, ""), 10)
}

export const roundRating = (rating: number) => {
  const base = Math.floor(rating)
  const fraction = rating - base

  if (fraction >= 0.85) return base + 0.9
  if (fraction >= 0.75) return base + 0.8
  if (fraction >= 0.65) return base + 0.7
  return Math.round(rating * 10) / 10
}

export const calculateAverage = (
  low: string | undefined,
  high: string | undefined,
): number => {
  const lowValue = getPriceValue(low) ?? 0
  const highValue = getPriceValue(high) ?? 0

  return (lowValue + highValue) / 2
}
